export default __webpack_public_path__ + "static/media/00.6975541f.jpg";